var React = require('react');

function IconLeadCancelled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-7.113 7.206A8.706 8.706 0 0 1 4.794 7.113l12.093 12.093Zm2.32-2.32L7.112 4.795a8.706 8.706 0 0 1 12.093 12.093Z"}));
}

IconLeadCancelled.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = IconLeadCancelled;

IconLeadCancelled.default = IconLeadCancelled;
